import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { BsCart4 } from "react-icons/bs";
import { translations } from "../../utils/translations.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  p {
    text-align: center;
  }
`;

const Title = styled.h2`
  color: var(--primary-brown);
  padding: 8px;
`;

interface SuccesfulOrderPlacementProps {
  isSucces: boolean;
}

const SuccesfulOrderPlacementComponent: React.FC<
  SuccesfulOrderPlacementProps
> = ({ isSucces }) => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);

  return (
    <Container>
      <BsCart4
        style={{
          fontSize: "100px",
          color: "var(--primary-brown)",
          margin: "0 auto",
        }}
      />
      <Title>
        {isSucces
          ? translations[languageCode]["chechout-success"]
          : translations[languageCode]["chechout-unpaied"]}
      </Title>
      {!isSucces && (
        <Title style={{ fontSize: "16px", margin: "0" }}>
          Plata nu a fost realizată! Puteți încerca din nou accesând secțiunea
          'Contul meu'!
        </Title>
      )}
      <p style={{ color: "var(--primary-brown)" }}>
        {translations[languageCode]["chechout-success-subtitle"]}
      </p>
    </Container>
  );
};

export default SuccesfulOrderPlacementComponent;
